import React from 'react';
import styles from './VehicleDetails.module.less';
import { Typography } from 'antd';
import classnames from 'classnames';

type VehicleDetailsProps = {
  vehicleModel: string;
  plateNumber: string;
  isBlock?: boolean;
};

const VehicleDetails = (props: VehicleDetailsProps) => {
  const { vehicleModel, plateNumber, isBlock } = props;
  const plateNumUpper = (plateNumber || '').toUpperCase();
  return (
    <div data-testid="vehicleDetails" className={styles.wrapper}>
      <div
        data-testid="vehicleDetails-info"
        className={classnames([styles.carModel, isBlock ? styles.blockDisplay : ''])}
      >
        <Typography.Text>{vehicleModel}</Typography.Text>
      </div>
      <div data-testid="vehicleDetails-plate" className={styles.numberPlate}>
        <Typography.Text type={'secondary'}>{plateNumUpper}</Typography.Text>
      </div>
    </div>
  );
};

export default VehicleDetails;
